import * as React from "react"
import { navigate } from "gatsby"
import {
  Button,
  Modal,
  ModalCard,
  StyledModal,
  StyledModalHeader,
  StyledModalBody,
  StyledModalActions,
  Text,
} from "gatsby-interface"
import { getPathToOrgPricing } from "@modules/organization/shared/utils"

export type LogDrainConnectBlockUpProps = {
  organizationId: string
  isOpen: boolean
  onDissmis: () => void
}

export function LogDrainConnectBlockUp({
  organizationId,
  isOpen = false,
  onDissmis,
}: LogDrainConnectBlockUpProps) {
  const handleClick = () => {
    onDissmis()

    navigate(getPathToOrgPricing(organizationId))
  }

  return (
    <Modal isOpen={isOpen} onDismiss={onDissmis}>
      <ModalCard>
        <StyledModal variant="ACTION">
          <StyledModalHeader onCloseButtonClick={onDissmis}>
            To connect with another log drain provider, upgrade your plan.
          </StyledModalHeader>
          <StyledModalBody>
            <StyledModalActions>
              <Button
                variant="SECONDARY"
                tone="NEUTRAL"
                type="button"
                onClick={onDissmis}
              >
                Back to site
              </Button>
              <Button variant="PRIMARY" type="submit" onClick={handleClick}>
                Upgrade plan
              </Button>
            </StyledModalActions>
          </StyledModalBody>
        </StyledModal>
      </ModalCard>
    </Modal>
  )
}
